export function listToTree(list, idKey = 'id', parentIdKey = 'parent_id', childrenKey = 'children') {
  const nodeMap = {};
  const tree = [];

  // 第一步：构建节点映射（先不设置空 children）
  list.forEach(item => {
    nodeMap[item[idKey]] = {
      value: item[idKey],
      label: item.name,
      tag: item.tag,
      // 这里先不赋值，后面再处理
    };
  });

  // 第二步：构建父子关系
  list.forEach(item => {
    const parentId = item[parentIdKey];
    const currentNode = nodeMap[item[idKey]];

    if (parentId === 0 || !nodeMap[parentId]) {
      tree.push(currentNode);
    } else {
      // 如果父节点没有 children，先初始化
      if (!nodeMap[parentId][childrenKey]) {
        nodeMap[parentId][childrenKey] = [];
      }
      nodeMap[parentId][childrenKey].push(currentNode);
    }
  });

  // 第三步：递归处理 —— 空数组 children 改为 undefined
  function formatEmptyChildren(nodes) {
    nodes.forEach(node => {
      if (node[childrenKey] && node[childrenKey].length === 0) {
        // 关键：空子级 → undefined，级联器就不会显示空白框
        node[childrenKey] = undefined;
      } else if (node[childrenKey]) {
        formatEmptyChildren(node[childrenKey]);
      }
    });
  }

  formatEmptyChildren(tree);
  return tree;
}